<template>
  <b-container>
    <div class="settings-page page">
      <div
        :class="[
          'page__card',
          {
            'page__card--account': tabIndex == 3
          }
        ]"
      >
        <div class="page__card__content">
          <b-tabs v-model="tabIndex" content-class="mt-3">
            <b-tab
              title="Edit Profile"
              title-link-class="nav-title"
              @click="setTab(0)"
            >
              <profile-form />
            </b-tab>
            <b-tab
              title="Payments"
              title-link-class="nav-title"
              @click="setTab(1)"
            >
              <payment-list />
            </b-tab>
            <b-tab
              title="Payouts"
              title-link-class="nav-title"
              @click="setTab(2)"
            >
              <payout-list />
            </b-tab>
            <b-tab
              title="Account Settings"
              title-link-class="nav-title"
              @click="setTab(3)"
            >
              <account-form />
            </b-tab>
          </b-tabs>
        </div>
      </div>
    </div>
    <div v-if="tabIndex == 3" class="page__card">
      <div class="page__card__content">
        <account-options />
      </div>
    </div>
  </b-container>
</template>
<script>
/**
 * ==================================================================================
 * Messages page
 * ==================================================================================
 **/

import ProfileForm from '@/components/forms/ProfileForm'
import PaymentList from '@/components/lists/PaymentList'
import PayoutList from '@/components/lists/PayoutList'
import AccountForm from '@/components/forms/AccountForm'
import AccountOptions from '@/components/cards/AccountOptions'

const HASH = ['#profile', '#payments', '#payouts', '#account']

export default {
  metaInfo: function() {
    return {
      title: 'My Account'
    }
  },
  components: {
    ProfileForm,
    PaymentList,
    PayoutList,
    AccountForm,
    AccountOptions
  },
  data: function() {
    return {
      tabIndex: 0
    }
  },

  methods: {
    setTab(index) {
      this.$router.push({
        name: 'user.settings-page',
        hash: HASH[index]
      })
    }
  },

  created() {
    this.tabIndex = HASH.indexOf(this.$route.hash)
  }
}
</script>
<style scoped lang="scss">
.settings-page {
  min-height: auto;

  .page__card--account {
    margin-bottom: 30px;

    .page__card__content {
      padding-bottom: 15px;
    }
  }
}

@media (max-width: 1200px) {
  .settings-page /deep/ {
    .nav-tabs {
      .nav-item {
        padding-right: 40px;
      }
    }
  }
}

@media (max-width: 1070px) {
  .settings-page /deep/ {
    .nav-tabs {
      .nav-item {
        padding-right: 30px;
      }
    }
  }
}

@media (max-width: 768px) {
  .settings-page /deep/ {
    .nav-tabs {
      justify-content: space-between;

      .nav-item {
        padding-left: 0px;
        padding-right: 0px;
      }
    }
  }
}
</style>
